import { Card, CardContent, Typography, Grid2 as Grid, Stack, Box } from "@mui/material";
import { useStyles } from "../../Search.styles";
import MoreActionsMenu from "../../../Menu/MoreActionsMenu";
import { onSearchResultSelectProps, PurchaseOrderSearchResultCardProps, SearchResultInvoicesProps } from "../../types";
import { ManualReceiveResultCard } from "./ManualReceiveResultCard";
import { manualReceiveMessage } from "../../constants";
import SearchResultLink from "./SearchResultLink";
import { useCallback } from "react";

export const PurchaseOrderSearchResultCard = ({
	searchDataSource,
	purchaseOrder,
	invoices,
	highlightInvoice,
	onSelect,
	onDisabledSelect,
	onOpenCheckin,
	actions,
	isShowActionMenuInHeader,
}: PurchaseOrderSearchResultCardProps) => {
	const classes = useStyles();
	const {
		purchaseOrderNumber,
		invoiceType,
		locationId,
		locationName,
		supplierName,
		status,
		allowManualReceive,
		isDisabled,
	} = purchaseOrder;
	// const onSearchResultSelect = ({ recType, invoiceNumber, receiveId, status }: onSearchResultSelectProps) => {
	// 	if (!isDisabled) {
	// 		onSelect(invoiceType, recType || "", purchaseOrderNumber, invoiceNumber, receiveId, status);
	// 	} else {
	// 		onDisabledSelect();
	// 	}
	// };

	const onSearchResultSelect = ({
		determinedReceiveType,
		purchaseOrderNumber,
		invoiceNumber,
		receiveId,
	}: onSearchResultSelectProps) => {
		if (!isDisabled) {
			onSelect(determinedReceiveType, purchaseOrderNumber, invoiceNumber, receiveId);
		} else {
			onDisabledSelect();
		}
	};

	const handleOpenCheckin = (invoiceNumber?: string) => {
		if (onOpenCheckin) onOpenCheckin(purchaseOrderNumber, invoiceNumber);
	};

	const getManualReceiveMessage = useCallback((invoiceType: string, invoices?: Array<SearchResultInvoicesProps>) => {
		switch (invoiceType) {
			case "EDI":
				return invoices && invoices.length ? manualReceiveMessage.EDI : manualReceiveMessage.EDILAM;
			case "Manual":
				return manualReceiveMessage.manual;
			default:
				return "";
		}
	}, []);

	return (
		<Card variant="outlined" className={classes.searchResultContainer}>
			<CardContent className={classes.searchResultCardContent}>
				<Stack spacing={0.5}>
					<Box display="flex" alignItems="center">
						<Box flexGrow={1}>
							<Typography display="inline" variant="caption" color="textSecondary" component="div">
								PO Number
							</Typography>
							<Typography display="inline" variant="body2" component="div" className={classes.purchaseOrderNumber}>
								{purchaseOrderNumber}
							</Typography>
						</Box>
						<Box>
							{isShowActionMenuInHeader && <MoreActionsMenu actions={actions} />}
						</Box>
					</Box>
					<Box display="flex">
						<Box flex="0 0 60%">
							<Typography variant="caption" color="textSecondary" component="div">
								Status
							</Typography>
							<Typography variant="body2" component="div">
								{status}
							</Typography>
						</Box>
						<Box>
							<Typography variant="caption" color="textSecondary" component="div">
								Invoice Type
							</Typography>
							<Typography variant="body2" component="div">
								{invoiceType}
							</Typography>
						</Box>
					</Box>
					<Box>
						<Typography variant="caption" color="textSecondary" component="div">
							Store
						</Typography>
						<Typography variant="body2" component="div">
							{locationId} - {locationName}
						</Typography>
					</Box>
					<Box>
						<Typography variant="caption" color="textSecondary" component="div">
							Supplier
						</Typography>
						<Typography variant="body2" component="div">
							{supplierName}
						</Typography>
					</Box>
					{Boolean(invoices?.length) && (
						<Box>
							{invoices?.map((invoice, i) => (
								<SearchResultLink
									key={`${invoice.invoiceNumber}_${i}`}
									receiveId={invoice.receiveId}
									receiveType={invoice.receiveType}
									invoiceType={invoiceType}
									purchaseOrderNumber={purchaseOrderNumber}
									invoiceNumber={invoice.invoiceNumber}
									totalQuantity={invoice.totalQuantity}
									totalCostInc={invoice.totalCostInc}
									status={invoice.status}
									searchDataSource={searchDataSource}
									highlight={highlightInvoice === invoice.invoiceNumber}
									onOpenCheckin={() => handleOpenCheckin(invoice.invoiceNumber)}
									onSelect={(determinedReceiveType) =>
										onSearchResultSelect({
											determinedReceiveType,
											purchaseOrderNumber,
											invoiceNumber: invoice.invoiceNumber,
											receiveId: invoice.receiveId,
										})
									}
								/>
							))}
						</Box>
					)}
					{allowManualReceive && (
						<Box>
							<ManualReceiveResultCard
								invoiceType={invoiceType}
								purchaseOrderNumber={purchaseOrderNumber}
								searchDataSource={searchDataSource}
								onSelect={(determinedReceiveType) =>
									onSearchResultSelect({
										determinedReceiveType,
										purchaseOrderNumber,
									})
								}
								message={getManualReceiveMessage(invoiceType, invoices)}
							/>
						</Box>
					)}
				</Stack>
			</CardContent>
		</Card>
	);
};
